/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestToJSON, FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseFromJSON, FxIdWebFeaturesProfileGetRequestToJSON, FxIdWebFeaturesProfileGetResponseFromJSON, FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSON, FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSON, } from '../models/index';
/**
 *
 */
export class ProfileApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesProfileFetchFxIdGameConnectionEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest', 'Required parameter "fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest" was null or undefined when calling fxIdWebFeaturesProfileFetchFxIdGameConnectionEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/fetch_fxid_game_connection`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesProfileFetchFxIdGameConnectionRequestToJSON(requestParameters['fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesProfileFetchFxIdGameConnectionResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesProfileFetchFxIdGameConnectionEndpoint(fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesProfileFetchFxIdGameConnectionEndpointRaw({ fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest: fxIdWebFeaturesProfileFetchFxIdGameConnectionRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **SELECTS:** `accounts`, `accounts_connections`, `social_identifiers`, `tag`, `taglink`    Get users\'s profile
     */
    async fxIdWebFeaturesProfileGetEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesProfileGetRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesProfileGetRequest', 'Required parameter "fxIdWebFeaturesProfileGetRequest" was null or undefined when calling fxIdWebFeaturesProfileGetEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesProfileGetRequestToJSON(requestParameters['fxIdWebFeaturesProfileGetRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesProfileGetResponseFromJSON(jsonValue));
    }
    /**
     * **SELECTS:** `accounts`, `accounts_connections`, `social_identifiers`, `tag`, `taglink`    Get users\'s profile
     */
    async fxIdWebFeaturesProfileGetEndpoint(fxIdWebFeaturesProfileGetRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesProfileGetEndpointRaw({ fxIdWebFeaturesProfileGetRequest: fxIdWebFeaturesProfileGetRequest }, initOverrides);
        return await response.value();
    }
    /**
     * **MUTATES:** `accounts`    Updates marketing field
     * @deprecated
     */
    async fxIdWebFeaturesProfileUpdateMarketingEnabledEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesProfileUpdateMarketingEnabledRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesProfileUpdateMarketingEnabledRequest', 'Required parameter "fxIdWebFeaturesProfileUpdateMarketingEnabledRequest" was null or undefined when calling fxIdWebFeaturesProfileUpdateMarketingEnabledEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/marketing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSON(requestParameters['fxIdWebFeaturesProfileUpdateMarketingEnabledRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * **MUTATES:** `accounts`    Updates marketing field
     * @deprecated
     */
    async fxIdWebFeaturesProfileUpdateMarketingEnabledEndpoint(fxIdWebFeaturesProfileUpdateMarketingEnabledRequest, initOverrides) {
        await this.fxIdWebFeaturesProfileUpdateMarketingEnabledEndpointRaw({ fxIdWebFeaturesProfileUpdateMarketingEnabledRequest: fxIdWebFeaturesProfileUpdateMarketingEnabledRequest }, initOverrides);
    }
    /**
     * **MUTATES:** `accounts`    Updates profile
     */
    async fxIdWebFeaturesProfileUpdateProfileSettingsEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesProfileUpdateProfileSettingsRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesProfileUpdateProfileSettingsRequest', 'Required parameter "fxIdWebFeaturesProfileUpdateProfileSettingsRequest" was null or undefined when calling fxIdWebFeaturesProfileUpdateProfileSettingsEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/profile/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesProfileUpdateProfileSettingsRequestToJSON(requestParameters['fxIdWebFeaturesProfileUpdateProfileSettingsRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * **MUTATES:** `accounts`    Updates profile
     */
    async fxIdWebFeaturesProfileUpdateProfileSettingsEndpoint(fxIdWebFeaturesProfileUpdateProfileSettingsRequest, initOverrides) {
        await this.fxIdWebFeaturesProfileUpdateProfileSettingsEndpointRaw({ fxIdWebFeaturesProfileUpdateProfileSettingsRequest: fxIdWebFeaturesProfileUpdateProfileSettingsRequest }, initOverrides);
    }
}
//# sourceMappingURL=ProfileApi.js.map